import { createApi } from '@reduxjs/toolkit/query/react'
import { createPublicApiBaseQuery } from './apiClients'

export const overlaySettingsApi = createApi({
    reducerPath: 'overlaySettingsApi',
    baseQuery: createPublicApiBaseQuery('overlaySettingsApi', { baseUrl: `${process.env.REACT_APP_API_BASE_URL}/overlay-settings` }),
    endpoints: (builder) => ({
        getOverlaySettings: builder.query({
            query: (token) => {
                return {
                    url: `/${token}`,
                    method: 'GET'
                }
            },
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response
        }),
    }),
})

export const { useGetOverlaySettingsQuery } = overlaySettingsApi
